import styled from 'styled-components'
import { Input as AntInput } from 'antd'

export const Input = styled(AntInput)`
  border-radius: 0.5rem;
`
